import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, Subscription, map} from 'rxjs';


import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { JobPlaintiff } from './../../../shared/models/jobPlaintiff.model';
import { AutoCompleteModule } from '@syncfusion/ej2-angular-dropdowns';

@Component({
  selector: 'app-job-plaintiff-add-widget',
  templateUrl: './job-plaintiff-add-widget.component.html',
  styleUrls: ['./job-plaintiff-add-widget.component.css']
})
export class JobPlaintiffAddWidgetComponent implements OnInit, OnChanges {
    // setup as observable?
    @Input() item_id?: Observable<any[]>; // impliments on changes.
    @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
    @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
    @Input() item_user_level_id? = '5'; // default to agent just in case
    @Input() item_brand_type_id? = '';
    @Input() show_buttons? = 'no'; // yes | no
    @Input() widget_title? = '';
    @Input() widget_size? = 'side'; // side | abstract | full
 
    job: Object;
    job_id;

    @Input() intialCount? = 221;
    @Input() count? = this.intialCount;
    @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

    model: JobPlaintiff;
  job_plaintiff_types: any;


      // defined the array of complex data
      public sportsData: string[] = ['Badminton', 'Basketball', 'Cricket', 'Football', 'Golf', 'Gymnastics'];
      // set a value to pre-select
      public value: string = '';
  job_plaintiffs: any;
  allPlaintiffs: any;
  allPlantiffs_menu: any;


  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService
  ) { }

  // check for changes. to load data.
  ngOnChanges(changes) {

    this.model = new JobPlaintiff();
    this.getJobPlaintiffTypes();
    this.getAllJobPlaintiffs();
    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.job_id = changes.item_id.currentValue;
      this.model.job_id = this.job_id;
      // this.getJob(this.job_id);
    }
  }


  ngOnInit() {
  }



  // Functions
getJob(job_id) {
  this._demoService.getJobID(job_id).subscribe(
     data => { this.job = data;
      let res = data[0];
      // Run the job data queries.
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 addJobPlaintiff(model) {
  this._demoService.addJobPlaintiff(model).subscribe(
    data => { },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
  this.toastr.info('Plaintiff & Type Added');
  this.closeParentModel.emit();
 }


 getJobPlaintiffTypes() {
  this._demoService.getJobPlaintiffTypes().subscribe(
     data => { this.job_plaintiff_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getAllJobPlaintiffs() {
  this.allPlaintiffs = [];
  this._demoService.getAllJobPlaintiffs().subscribe(
     data => { this.job_plaintiffs= data;
    
      let newArr = data;
      let  count_of_items = Object.keys(newArr).length;
        // need to do a loop of subject_billing items (.length)
        for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
        this.allPlaintiffs.push(
          res.job_plaintiff_name
        );
        } // end for loop
    
        console.log('this.allPlaintiffs: ', JSON.stringify(this.allPlaintiffs));
         this.allPlantiffs_menu = this.allPlaintiffs; //
        // console.log('result', this.allPlantiffs_menu);

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


}
